import { pendingMutationKeyHandles, pendingMutationsUseKey } from "./pending-recovery-transports.js";
import { parseStored } from "./runtime-utils.js";
export function storedTokenKeyHandles(token, additional) {
    const handles = new Set();
    if (additional)
        handles.add(additional);
    if (token?.keyHandle)
        handles.add(token.keyHandle);
    if (Array.isArray(token?.retiredKeyHandles)) {
        for (const handle of token.retiredKeyHandles) {
            if (typeof handle === "string" && handle.length > 0)
                handles.add(handle);
        }
    }
    return handles;
}
export function planRetiredGrantKeys(storage, pendingMutationKey, previous, current, leased = [], retainAll = false) {
    const retained = [];
    const disposable = [];
    const candidates = storedTokenKeyHandles(previous);
    for (const handle of pendingMutationKeyHandles(storage, pendingMutationKey)) {
        candidates.add(handle);
    }
    const leasedHandles = new Set(leased);
    for (const handle of leasedHandles)
        candidates.add(handle);
    for (const handle of candidates) {
        if (handle === current)
            continue;
        (retainAll || leasedHandles.has(handle) || pendingMutationsUseKey(storage, pendingMutationKey, handle)
            ? retained
            : disposable).push(handle);
    }
    return { retained, disposable };
}
export function removeRetiredGrantKeyMetadata(storage, tokenKey, handle) {
    const token = parseStored(storage.getItem(tokenKey));
    if (!token || !Array.isArray(token.retiredKeyHandles))
        return;
    const retiredKeyHandles = token.retiredKeyHandles.filter((candidate) => candidate !== handle);
    if (retiredKeyHandles.length === token.retiredKeyHandles.length)
        return;
    if (retiredKeyHandles.length > 0)
        token.retiredKeyHandles = retiredKeyHandles;
    else
        delete token.retiredKeyHandles;
    storage.setItem(tokenKey, JSON.stringify(token));
}
export async function deleteUnusedGrantKey(storage, keyStore, pendingMutationKey, tokenKey, handle) {
    const current = parseStored(storage.getItem(tokenKey));
    if (current?.keyHandle === handle
        || pendingMutationsUseKey(storage, pendingMutationKey, handle))
        return;
    await keyStore.delete(handle);
    removeRetiredGrantKeyMetadata(storage, tokenKey, handle);
}
